import React from 'react';
import { Check, Layers, Palette, Volume2, Cloud } from 'lucide-react';
import { useLang } from '../context/LangContext';

const Showcase = () => {
  const { t } = useLang();
  const icons = [Layers, Palette, Volume2, Cloud];
  const points = [t.showcase.point1, t.showcase.point2, t.showcase.point3, t.showcase.point4];

  return (
    <section id="showcase" className="py-24 md:py-32 bg-neutral-950 text-white overflow-hidden relative">
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 -left-40 w-[400px] h-[400px] bg-cyan-500/50 rounded-full blur-[100px]" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-fuchsia-500/40 rounded-full blur-[120px]" />
      </div>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 relative">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <h2 className="text-[40px] md:text-[64px] font-black tracking-[-0.02em] leading-[1.02]">{t.showcase.title}</h2>
            <p className="mt-6 text-[17px] text-neutral-400 leading-relaxed">{t.showcase.desc}</p>
            <div className="mt-10 space-y-4">
              {points.map((p, i) => {
                const Ic = icons[i];
                return (
                  <div key={i} className="flex items-center gap-4 group">
                    <div className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-white/10 group-hover:border-white/20 transition-colors">
                      <Ic className="w-5 h-5 text-cyan-400" />
                    </div>
                    <span className="text-[16px] font-medium text-neutral-200">{p}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-6 bg-gradient-to-br from-cyan-500/20 via-transparent to-fuchsia-500/20 blur-2xl rounded-3xl" />
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
              <img src="https://images.unsplash.com/photo-1611162616475-46b635cb6868?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" alt="editor" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 rtl:left-auto rtl:right-6 right-6 rtl:right-auto rtl:left-6">
                <div className="space-y-1.5">
                  {['w-full bg-cyan-400', 'w-3/4 bg-fuchsia-400', 'w-1/2 bg-amber-400'].map((cl, i) => (
                    <div key={i} className="h-2 bg-white/10 rounded-full overflow-hidden">
                      <div className={`h-full rounded-full ${cl}`} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Showcase;
